module.exports = __webpack_public_path__ + "static/media/manual_de_uso.b3c9d4df.pdf";


//////////////////
// WEBPACK FOOTER
// ./src/media/manual_de_uso.pdf
// module id = 313
// module chunks = 0